import {
    PromotionalCard as PromotionalCardType,
    PromotionalCardType as PromotionalCardTypes,
} from 'types/generated';

export const filterCards = ({
    cards = [],
    get,
    isDAWPlugin,
    isTablet,
}: {
    cards?: PromotionalCardType[];
    get: (flag: string) => boolean;
    isDAWPlugin: boolean;
    isTablet: boolean;
}): PromotionalCardType[] => {
    const filteredCards: PromotionalCardType[] = [];
    const staticCards: PromotionalCardType[] = [];

    cards.forEach((card) => {
        if (
            card.type === PromotionalCardTypes.Plugin &&
            !isTablet &&
            !get('SamplesPageLoadedInPlugin')
        ) {
            filteredCards.push(card);
            return;
        }

        if (
            card.type === PromotionalCardTypes.QuickPicks &&
            !get('QuickPicksLoadedPages')
        ) {
            filteredCards.push(card);
            return;
        }

        if (
            card.type === PromotionalCardTypes.Creator &&
            !isDAWPlugin &&
            !get('SampleAddedToCreator')
        ) {
            filteredCards.push(card);
            return;
        }

        if (card.type === PromotionalCardTypes.None && !get(card.id)) {
            filteredCards.push(card);
            return;
        }
    });

    // This static cards array is concatened to the filtred cards array when there's only one Milestone left. We always need two cards.
    // Its basically a reversed array of all the cards without any Milestone logic. This way, we kept the last cards already displayed if there's no other cards to show.
    cards
        .slice()
        .reverse()
        .forEach((card) => {
            if (!filteredCards.includes(card)) {
                staticCards.push(card);
                return;
            }
        });

    return filteredCards.length > 2
        ? filteredCards
        : filteredCards.concat(staticCards).slice(0, 2);
};
